import React from 'react';
import clsx from 'clsx';
import { Check } from 'lucide-react';

interface Props {
  label?: string;
  checked: boolean;
  onChange: (val: boolean) => void;
  disabled?: boolean;
  className?: string;
  variant?: 'primary' | 'secondary';
}

const Checkbox: React.FC<Props> = ({
  label,
  checked,
  onChange,
  disabled = false,
  className,
  variant = 'primary',
}) => {
  const checkedClassName =
    variant === 'secondary' ? 'bg-black border-black' : 'bg-primary border-primary ';

  return (
    <label
      className={clsx(
        'shrink-0 flex items-center gap-1 select-none font-semibold',
        disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer',
        className
      )}
    >
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
        className="sr-only peer"
      />

      <div
        className={clsx(
          'w-4 h-4 shrink-0 inline-flex items-center justify-center rounded-[3px] border transition',
          checked ? checkedClassName : 'border-black',
          'peer-focus:ring-[3px] peer-focus:ring-blue-300/50'
        )}
      >
        {checked && <Check strokeWidth={2.2} size={10} absoluteStrokeWidth className="shrink-0 text-white" />}
      </div>

      {label && <span className="text-sm">{label}</span>}
    </label>
  );
};

export default Checkbox;
